export const API_URL = process.env.REACT_APP_ENV === "DEV" ? process.env.REACT_APP_API_URL_DEV + "/api":  process.env.REACT_APP_API_URL_PROD+ "/api";